import type { MetricResult } from '@/api/snapshot'
import type { ContinuitySnapshot } from '@/api/continuity-snapshot'
import type { ContinuityMetricId } from '@/types/intelligence'

/** The care journey shares an objective can be set on (DECISIONS.md #45): steps 2 to 5's lead measures. */
export const OBJECTIVE_CARE_METRIC_IDS: readonly ContinuityMetricId[] = [
  'METRIC-CONT-CAREPLAN-ACT',
  'METRIC-CONT-PT-CONNECT',
  'METRIC-CONT-90D-RETENTION',
  'METRIC-CONT-LOOP-CLOSURE',
]

/** What an objective can be set on, and where it stands now: its starting point if set today. */
export interface ObjectiveMeasure {
  metricId: string
  /** Null when it has no figure now: it cannot take an objective. */
  value: number | null
  unit: 'COUNT' | 'MINUTES' | 'PERCENT'
  betterWhen: 'LOWER' | 'HIGHER' | null
}

/**
 * The Overview's five metrics over the last 30 days, then the care journey's
 * shares as they stand, in percent to a tenth as the server takes them: what
 * Set objective offers. Null while the five are loading; the care shares are
 * offered once their snapshot is in, or with no figure when it could not be
 * read, so the form says they cannot take one rather than loading forever.
 */
export const objectiveMeasures = (
  metrics: MetricResult[] | undefined,
  care: ContinuitySnapshot | undefined,
  careFailed = false,
): ObjectiveMeasure[] | null => {
  if (!metrics) return null
  const operations = metrics.map((metric): ObjectiveMeasure => ({ metricId: metric.metricId, value: metric.value, unit: metric.unit, betterWhen: metric.betterWhen }))
  const shares = OBJECTIVE_CARE_METRIC_IDS.flatMap((metricId): ObjectiveMeasure[] => {
    if (careFailed) return [{ metricId, value: null, unit: 'PERCENT', betterWhen: 'HIGHER' }]
    const stage = care?.stages.find((candidate) => candidate.metricId === metricId)
    return stage ? [{ metricId, value: stage.rate === null ? null : Math.round(stage.rate * 1000) / 10, unit: 'PERCENT', betterWhen: 'HIGHER' }] : []
  })
  return [...operations, ...shares]
}
